import { useEffect, useState } from "react";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "./firebase";
import { useInView } from "react-intersection-observer";
import { useNavigate } from "react-router-dom";

// --- Reusable Component for Portfolio Items ---
function PortfolioItem({ item }) {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const media = item.media?.[0];
  const type = media?.type;
  const url = media?.url;

  const navigate = useNavigate();

  const handleVideoMetadata = (e) => {
    const { videoWidth, videoHeight } = e.target;
  };

  return (
    <div
      className={`portfolio-item padd-15 filter-item project-card ${item.tag.toLowerCase()}`}
      ref={ref}
      onClick={() => navigate(`/project/${item.id}`)}
      style={{ cursor: "pointer" }}
    >
      <div className="portfolio-item-inner">
        <div className="portfolio-img">
          {type === "video" ? (
            inView ? (
              <video
                src={url}
                muted
                controls
                width="100%"
                height="200px"
                style={{ objectFit: "cover" }}
                preload="auto"
                playsInline
                onLoadedMetadata={handleVideoMetadata}
              />
            ) : (
              <div
                style={{
                  width: "100%",
                  height: "200px",
                  backgroundColor: "#111",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#aaa",
                  fontSize: "14px",
                }}
              >
                Loading video...
              </div>
            )
          ) : (
            <img
              src={`${url}&width=300`}
              alt={item.title}
              loading="lazy"
              style={{
                width: "100%",
                height: "200px",
                objectFit: "cover",
              }}
            />
          )}
        </div>
        <h3>{item.title}</h3>
      </div>
    </div>
  );
}

// --- Main Portfolio Component ---
export default function Portfolio() {
  const [portfolioItems, setPortfolioItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const q = query(
          collection(db, "projects"),
          orderBy("timestamp", "desc")
        );
        const snapshot = await getDocs(q);
        const projects = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setPortfolioItems(projects);
      } catch (error) {
        console.error("Error fetching portfolio data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const filterButtons = document.querySelectorAll(".filter__item__button");
    const filterItems = document.querySelectorAll(".filter-item");

    filterButtons.forEach((button) => {
      button.addEventListener("click", () => {
        filterButtons.forEach((btn) => btn.classList.remove("active-work"));
        button.classList.add("active-work");

        const filterValue = button.getAttribute("data-filter");

        filterItems.forEach((item) => {
          item.style.display =
            filterValue === "all" ||
            item.classList.contains(filterValue.substring(1))
              ? "block"
              : "none";
        });
      });
    });

    return () => {
      filterButtons.forEach((button) => {
        button.replaceWith(button.cloneNode(true));
      });
    };
  }, [portfolioItems]);

  return (
    <section className="portfolio section" id="portfolio">
      <div className="container">
        <div className="row">
          <div className="section-title padd-15">
            <h2>Portfolio</h2>
          </div>
        </div>

        <div className="row">
          <div className="portfolio-heading padd-15">
            <h2>My works :</h2>
          </div>
        </div>

        {/* Filter Buttons */}
        <div className="filters scroll-y">
          <span className="filter__item__button active-work" data-filter="all">
            All
          </span>
          <span className="filter__item__button" data-filter=".3d">
            3D
          </span>
          <span className="filter__item__button" data-filter=".vfx">
            VFX
          </span>
          <span className="filter__item__button" data-filter=".animation">
            Animation
          </span>
          <span className="filter__item__button" data-filter=".motion">
            Motion Graphics
          </span>
          <span className="filter__item__button" data-filter=".graphics">
            Graphics Design
          </span>
        </div>

        {/* Loading Animation or Portfolio Items */}
        {loading ? (
          <div className="loading-dots-container">
            <div className="loading-dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <p>Loading Portfolio...</p>
          </div>
        ) : (
          <div className="row">
            {portfolioItems.map((item) => (
              <PortfolioItem key={item.id} item={item} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
